import React, { FunctionComponent, useEffect } from 'react';
import { RowContainer } from './InfoBlock';
import { useMessageGetter } from 'react-message-context';
import { useKennoTenant } from '../../../context/kennoTenantContext';
import { loadBuilding } from '../../../context/kennoTenantActions';

const AdditionalBuildingInfo: FunctionComponent = () => {
  const t = useMessageGetter('');
  const [{ building }, dispatch] = useKennoTenant();

  useEffect(() => {
    loadBuilding(dispatch);
  }, [dispatch]);

  const emergencyNumber = building.data?.maintenanceCompany.emergencyNumber;
  const maintenanceCompanyName = building.data?.maintenanceCompany.name;

  /* This logic is copied from AgreementPage. Let's see how Kenno provides water payment
  information, since this has some issues. For example if payment is included in rent,
  the information is provided only in 'additional info' field
  which can contain any text. Therefore no english translation available.*/

  /*   const getWaterPayment = () => {
    if (agreement.waterPrePayment) return `${formatMoney(agreement.waterPrePayment)} ${t('agreement.personmonth')}`;
    if (agreement.waterPerPerson) return `${formatMoney(agreement.waterPerPerson)} ${t('agreement.personmonth')}`;
    if (agreement.waterPerConsumption)
      return `${formatMoney(agreement.waterPerConsumption)} ${t('agreement.permonth')}`;
    if (apartment.info.waterDescription) return apartment.info.waterDescription;
    return '-';
  };

  const internetSlug = getInternetSlug(housingInfo?.isp, housingInfo?.broadbandType); */

  return (
    <dl>
      {/*       <RowContainer>
        <dt>{t('housing.housefeat.laundryroom')}</dt>
        <dd>{housingInfo.laundry ? t('housing.yes') : t('housing.no')}</dd>
      </RowContainer>
      <RowContainer>
        <dt>{t('housing.internet.title')}</dt>
        <dd>{t(`housing.internet.${internetSlug}`)}</dd>
      </RowContainer>
      <RowContainer>
        <dt>{t('agreement.lease.waterPerPerson')}</dt>
        <dd>{getWaterPayment()}</dd>
      </RowContainer> */}
      <RowContainer>
        <dt>{t('housing.maintenanceCompany')}</dt>
        <dd>
          {maintenanceCompanyName && maintenanceCompanyName}
          {/*           {housing?.maintenance?.companyPhone && (
            <div>
              {`${t('housing.contacts.customerservice')}: `}
              <a href={`tel: ${housing?.maintenance?.companyPhone}`}>{housing?.maintenance?.companyPhone}</a>
            </div>
          )} */}
          {emergencyNumber && (
            <div>
              {`${t('housing.contacts.emergency')}: `}
              <a href={`tel: ${emergencyNumber}`}>{emergencyNumber}</a>
            </div>
          )}
        </dd>
      </RowContainer>
    </dl>
  );
};

export default AdditionalBuildingInfo;
